<template>
  <div>
    <p>
      <time :datetime="startedAt" v-if="startedAt">{{$t('js.backend.voter_importer.started_time_ago', {time_ago: startedAgo})}}</time>
      <span v-else>{{ $t('js.backend.voter_importer.starting_soon') }}</span>
    </p>
    <div class="progress mb-5">
        <div class="progress-bar" role="progressbar" :aria-valuenow="count" aria-valuemin="0" :aria-valuemax="total" :style="{width: progress}">
          {{ `${count}/${total}` }}
        </div>
    </div>
  </div>
</template>

<script>
import apiClient from "../../packs/frontend/apiClient";
export default {
  name: "ImporterProgressBar",
  props: {
    importerId: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    initialCount: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 100
    }
  },
  data(){return {
    count: this.initialCount,
    reloading: false,
    intervalId: null,
    startedAt: null,
    startedAgo: null,
  }},
  computed: {
    progress(){
      return `${Math.round(100 * this.count / this.total)}%`;
    }
  },
  beforeMount() {
    this.relative_time = new Intl.RelativeTimeFormat(document.documentElement.lang, { numeric: "auto" });
  },
  mounted(){
    this.intervalId = setInterval(this.checkStatus, 500)
    setInterval(this.updateTimestamp, 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    updateTimestamp(){
      if(!this.startedAt) return
      let value = Math.round((this.startedAt-Date.now())/1000)
      let unit = Math.abs(value) >= 60 ? 'minute' : 'second'
      this.startedAgo = this.relative_time.format(value, unit)
    },
    async checkStatus(){
      let response = await apiClient.get(window.location.href)
      this.count = response.data.counts[this.status];
      this.startedAt = Date.parse(response.data.started_ats[this.status]);
      this.updateTimestamp()
      if(response.data.status && response.data.status !== this.status){
        this.reloadPage()
        document.getElementById('cancel-button').classList.add('disabled')
      }
    },
    reloadPage(){
      window.clearInterval(this.intervalId)
      if(this.reloading) return;
      this.reloading = true
      setTimeout(() => window.location.reload(), 500) // Small delay, so the user can see the progressbar hit 100%
    },
  }
}
</script>